import React from 'react';
import { Marker } from '@vis.gl/react-google-maps';
import { LocationWithCoordinates } from 'lib/types';
import useWindowSize from 'core/hooks/useWindowSize';
import markerIcon from 'assets/marker.svg';
import markerActive from 'assets/marker_active.svg';

interface LocationMarkerProps {
    location: LocationWithCoordinates;
    onSelect?: (locationId: string) => void;
    selected?: boolean;
}

const ICON_RATIO = 52.0 / 42.0;

function LocationMarker({
    selected,
    onSelect,
    location: { name, coordinates, _id },
}: LocationMarkerProps) {
    const { width } = useWindowSize();

    const icon = React.useMemo(() => {
        const bigIcon = width > 414;
        const iconWidth = selected ? 54 : bigIcon ? 42 : 28;
        const iconHeight = Math.round(iconWidth * ICON_RATIO);
        return {
            url: selected ? markerActive : markerIcon,
            scaledSize: new google.maps.Size(iconWidth, iconHeight),
        };
    }, [width, selected]);

    const position = React.useMemo(() => {
        if (coordinates) {
            return {
                lat: coordinates.latitude,
                lng: coordinates.longitude,
            };
        }
        return null;
    }, [coordinates]);

    const handleClick = () => {
        if (onSelect) {
            onSelect(_id);
        }
    };

    if (!position) return null;

    return (
        <Marker
            position={position}
            title={name}
            icon={icon}
            onClick={handleClick}
        />
    );
}

export default LocationMarker;
